<script setup lang="ts">
  import type { RestConfig } from '@solfacil/plasma-utils';
  import { useApi } from '@solfacil/plasma-utils';

  import UserApi from './apis/ecommerce/UserApi';
  import { useUser } from './composables/user';

  if (!useRoute().meta.public) {
    await new UserApi(useApi('ecommerce' as RestConfig))
      .getUser()
      .then(result => {
        useUser().set(result);
      });
  }
</script>

<template>
  <div class="app-root">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
